var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroLabelIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_656_2121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3301 1.33301H2.66602C1.92982 1.33301 1.33301 1.92982 1.33301 2.66602V5.33203C1.33301 6.06823 1.92982 6.66504 2.66602 6.66504H13.3301C14.0663 6.66504 14.6631 6.06823 14.6631 5.33203V2.66602C14.6631 1.92982 14.0663 1.33301 13.3301 1.33301Z",
    stroke: "#057DCD",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3301 9.33105H2.66602C1.92982 9.33105 1.33301 9.92786 1.33301 10.6641V13.3301C1.33301 14.0663 1.92982 14.6631 2.66602 14.6631H13.3301C14.0663 14.6631 14.6631 14.0663 14.6631 13.3301V10.6641C14.6631 9.92786 14.0663 9.33105 13.3301 9.33105Z",
    stroke: "#057DCD",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99902 3.99902H4.00569",
    stroke: "#057DCD",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99902 11.9971H4.00569",
    stroke: "#057DCD",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_656_2121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9961,
    height: 15.9961,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroLabelIcon);
export default __webpack_public_path__ + "static/media/hero-label-icon.f6a64da4692031f2ee4ed7288ab0f240.svg";
export { ForwardRef as ReactComponent };